import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../Style";
import Accordion from "react-bootstrap/Accordion";

import { editArrival } from "../../../store/reducers/guestsReducer";
import { CFV, handleClickScroll } from "../others/Functions";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import OpacityLoading from "../loader/OpacityLoading";
import tsim from "../../../assets/common/tsim.png";
import tiv from "../../../assets/common/tiv.png";
import glut from "../../../assets/common/glut.png";
import glat from "../../../assets/common/glat.png";
import { useEffect } from "react";

const Submit = ({
  transportation,
  specialMsg,
  specialMsgDetails,
  transportationDetails,
  specialDishes,
  acceptLimit,
  init,
  isDemo,
  setDone,
  blessing,
  blessTitle,
  heartColor,
  gId,
  separation,
  selfFullname,
  selfPhone,
  uId,
}) => {
  // useEffect(() => {
  //   setTimeout(function () {
  //     handleClickScroll("vb");
  //   }, 2000);
  // }, []);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    let isOk = true;
    let notes = "";
    let accept;
    let acceptWomen;
    let acceptMen;
    if (separation) {
      accept = null;
      acceptWomen =
        data?.acceptWomen?.length < 1 || data.acceptWomen === undefined
          ? null
          : parseInt(data.acceptWomen);
      acceptMen =
        data?.acceptMen?.length < 1 || data.acceptMen === undefined
          ? null
          : parseInt(data.acceptMen);
    } else {
      acceptWomen = null;
      acceptMen = null;
      accept =
        data.accept === undefined || data.accept === ""
          ? null
          : parseInt(data.accept);
    }
    if (separation && acceptMen === null && acceptWomen === null) {
      isOk = false;
      toast.warning("נא לסמן הגעה בשורה הראשונה בטופס");
    } else if (separation) {
      accept = 0;
      accept += acceptWomen !== null ? acceptWomen : 0;
      accept += acceptMen !== null ? acceptMen : 0;
    }
    if (isOk) {
      let body = {
        accept,
        acceptWomen,
        acceptMen,
        ans: selfFullname.length ? "S" : "L",
        dishes: specialDishes
          ? [
              parseInt(data.glut),
              parseInt(data.tsim),
              parseInt(data.tiv),
              parseInt(data.glat),
            ]
          : [0, 0, 0, 0],
      };
      if (data?.notes?.length) notes += `\n${data.notes}`;
      if (data?.bless?.length) notes += `\n${data.bless}`;
      if (data?.transportation != 0)
        body = { ...body, transportation: data.transportation };
      body = { ...body, notes, selfFullname, selfPhone, uId };

      if (isDemo) {
        toast.success("הפעולה בוצעה בהצלחה");
        setDone(true);
        init(false);
      } else {
        setLoading(true);
        dispatch(editArrival(gId, body)).then((res) => {
          setLoading(false);
          if (!res.payload?.error) {
            toast.success("הפעולה בוצעה בהצלחה");
            setDone(true);
            init(false);
          } else toast.error(res.payload?.error);
        });
      }
    }
  };
  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        {separation ? (
          <FlexRowBetween>
            <div style={{ width: "40%" }}>
              <Label>כמות מגיעים גברים</Label>
              <Input
                type="number"
                {...register("acceptMen", {
                  min: 1,
                  max: acceptLimit,
                })}
              />
              {CFV(`acceptMen`, `מספר בין 1 ל ${acceptLimit}`, errors)}
            </div>
            <div style={{ width: "40%" }}>
              <Label>כמות מגיעים נשים</Label>
              <Input
                type="number"
                {...register("acceptWomen", {
                  min: 1,
                  max: acceptLimit,
                })}
              />
              {CFV(`acceptWomen`, `מספר בין 1 ל ${acceptLimit}`, errors)}
            </div>
          </FlexRowBetween>
        ) : (
          <>
            <Label
              csize={"20px"}
              psize={"18px"}
              style={{
                textDecoration: "underline",
                textDecorationColor: heartColor,
              }}
            >
              כמות מגיעים
            </Label>
            <Input
              type="number"
              {...register("accept", {
                required: true,
                min: 1,
                max: acceptLimit,
              })}
            />
            {CFV(`accept`, `מספר בין 1 ל ${acceptLimit}`, errors)}
          </>
        )}

        {/* <div>
          אורחים יקרים, במידה והנכם צריכים הסעה, אנא מלאו את הטופס הבא (אם אתם
          זוג או יותר, אנא מלאו עבור כל אחד מהאורחים)
          <br />
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://forms.gle/oboTF9eCyTdTeK6M6`}
          >
            https://forms.gle/oboTF9eCyTdTeK6M6
          </a>{" "}
          <br />
          לקבוצת הוואטסאפ הסעות ת"א -
          <br />
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://chat.whatsapp.com/JzACpvcqOBvAXnl3U5mKir`}
          >
            https://chat.whatsapp.com/JzACpvcqOBvAXnl3U5mKir
          </a>{" "}
          <br />
          לקבוצת הוואטסאפ הסעות חיפה - <br />
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://chat.whatsapp.com/ExbOidm5SxcGIxMc2Q41NB`}
          >
            https://chat.whatsapp.com/ExbOidm5SxcGIxMc2Q41NB
          </a>
        </div> */}
        {/* {specialMsg && <div>{specialMsgDetails}</div>} */}
        {/* {specialMsgDetails.split("??").map((x, i) => {
          xxx.apend(<div key={i + x}>{x}</div>);
        })} */}
        {/* {xxx} */}
        {specialMsg && (
          <div
            style={{ marginBottom: "20px" }}
            dangerouslySetInnerHTML={{ __html: specialMsgDetails }}
          />
        )}

        {transportation && (
          <Accordion>
            <Accordion.Item
              eventKey="0"
              style={{ borderTop: "1.3px solid #dee2e6" }}
            >
              <Accordion.Header>
                <div style={{ paddingLeft: "20px" }}>הסעה</div>
              </Accordion.Header>
              <Accordion.Body style={{ background: "#dddada" }}>
                <Label>כמות מגיעים בהסעה</Label>
                <Input
                  defaultValue={0}
                  type="number"
                  {...register("transportation", {
                    min: 0,
                    max: acceptLimit,
                  })}
                />
                {CFV(`transportation`, `מספר בין 0 ל ${acceptLimit}`, errors)}

                <Label>בקשות מיוחדות</Label>
                <TextArea
                  defaultValue={""}
                  placeholder="במידה ויש מספר הסעות נא לכתוב כאן לאיזו תרצו להשתייך"
                  type="text"
                  rows="2"
                  {...register("notes", {
                    minLength: 0,
                    maxLength: 500,
                  })}
                />
                {CFV("notes", "עד 500 תווים", errors)}

                <Label>פרטי ההסעה</Label>
                <TextArea
                  disabled={true}
                  type="text"
                  rows="3"
                  placeholder={transportationDetails}
                  style={{ color: "#3a3c3f" }}
                />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}

        {specialDishes && (
          <Accordion>
            <Accordion.Item
              eventKey="1"
              style={{ borderTop: "1.3px solid #dee2e6" }}
            >
              <Accordion.Header>
                <div style={{ paddingLeft: "20px" }}>בקשה למנות מיוחדות</div>
              </Accordion.Header>
              <Accordion.Body style={{ background: "#dddada" }}>
                <FlexRowBetween style={{ marginTop: "15px" }}>
                  <div style={{ width: "20%" }}>
                    <img
                      src={glut}
                      alt="glut"
                      style={{ width: "35px", marginBottom: "10px" }}
                    />
                    <Input
                      defaultValue={0}
                      type="number"
                      {...register("glut", {
                        min: 0,
                        max: acceptLimit,
                      })}
                    />
                    {CFV(`glut`, `מספר בין 0 ל ${acceptLimit}`, errors)}
                  </div>

                  <div style={{ width: "20%" }}>
                    <img
                      src={tsim}
                      alt="tsim"
                      style={{ width: "40px", marginTop: "-11px" }}
                    />
                    <Input
                      style={{ marginTop: "7px" }}
                      defaultValue={0}
                      type="number"
                      {...register("tsim", {
                        min: 0,
                        max: acceptLimit,
                      })}
                    />
                    {CFV(`tsim`, `מספר בין 0 ל ${acceptLimit}`, errors)}
                  </div>

                  <div style={{ width: "20%" }}>
                    <img
                      src={tiv}
                      alt="tiv"
                      style={{ width: "40px", marginTop: "-11px" }}
                    />
                    <Input
                      style={{ marginTop: "7px" }}
                      defaultValue={0}
                      type="number"
                      {...register("tiv", {
                        min: 0,
                        max: acceptLimit,
                      })}
                    />
                    {CFV(`tiv`, `מספר בין 0 ל ${acceptLimit}`, errors)}
                  </div>

                  <div style={{ width: "20%" }}>
                    <img
                      src={glat}
                      alt="glat"
                      style={{ width: "35px", marginBottom: "10px" }}
                    />
                    <Input
                      defaultValue={0}
                      type="number"
                      {...register("glat", {
                        min: 0,
                        max: acceptLimit,
                      })}
                    />
                    {CFV(`glat`, `מספר בין 0 ל ${acceptLimit}`, errors)}
                  </div>
                </FlexRowBetween>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}

        {blessing && (
          <Accordion>
            <Accordion.Item
              eventKey="2"
              style={{ borderTop: "1.3px solid #dee2e6" }}
            >
              <Accordion.Header>
                <div style={{ paddingLeft: "20px" }}>{`${blessTitle}`}</div>
              </Accordion.Header>
              <Accordion.Body style={{ background: "#dddada" }}>
                <TextArea
                  type="text"
                  rows="3"
                  {...register("bless", {
                    minLength: 0,
                    maxLength: 500,
                  })}
                />
                {CFV("bless", "עד 500 תווים", errors)}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )}
        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%", background: heartColor }} id="vb">
            שליחה
          </Button>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default Submit;
